import utilRouter from "@/libs/util.router.js";
const config = {
  navMenuConfig: {
    title: "人民课程思政",
    menuBackgroundColor: "#CD2224",
    menuTextColor: "#fff",
    menuActiveTextColor: "#fff",
  },
  menuList: [
    {
      title: "首页",
      type: 1,
      content: "/whkcsz/portal",
      subMenuList: [],
      menu: "portal",
      isActive: utilRouter.isMetaActive,
    },
    {
      title: "示范课程",
      type: 1,
      content: "/whkcsz/courses",
      subMenuList: [],
      menu: "courses",
      isActive: utilRouter.isMetaActive,
    },
    {
      title: "师资培训",
      type: 1,
      content: "/whkcsz/teachers",
      subMenuList: [],
      menu: "teachers",
      isActive: utilRouter.isMetaActive,
    },
    {
      title: "资源库",
      type: 2,
      content: "https://rm.ulearning.cn/#/portal/11",
      subMenuList: [],
      menu: "resource",
      isActive: utilRouter.isMetaActive,
    },
    {
      title: "内容审核",
      type: 1,
      content: "/whkcsz/review",
      subMenuList: [],
      menu: "review",
      isActive: utilRouter.isMetaActive,
    },
    {
      title: "赛事服务",
      type: 1,
      content: "/whkcsz/contest",
      subMenuList: [],
      menu: "contest",
      isActive: utilRouter.isMetaActive,
    },
    {
      title: "融合出版",
      type: 1,
      content: `/whkcsz/publish`,
      subMenuList: [],
      menu: "publish",
      isActive: utilRouter.isMetaActive,
    },
    {
      title: "新闻资讯",
      type: 1,
      content: "/whkcsz/news",
      subMenuList: [],
      menu: "news",
      isActive: utilRouter.isMetaActive,
    },
    {
      title: "合作院校",
      type: 1,
      content: "/whkcsz/colleges",
      subMenuList: [],
      menu: "colleges",
      isActive: utilRouter.isMetaActive,
    },
  ],
  colleges: [
    {
      pic: "1-bjlhdx.png",
      link: "https://kcsz.buu.edu.cn/",
    },
    {
      pic: "2-bjhgdx.png",
      link: "",
    },
    {
      pic: "3-qdnydx.png",
      link: "https://qau.ulearning.cn/kcsz/#/kcsz/portal",
    },
    {
      pic: "4-hbgydx.png",
      link: "",
    },
    {
      pic: "5-dlhsdx.png",
      link: "",
    },
    {
      pic: "6-hbdldx.png",
      link: "",
    },
    {
      pic: "7-dglgxy.png",
      link: "",
    },
    {
      pic: "8-whgcdx.png",
      link: "",
    },
    {
      pic: "9-sdsfdx.png",
      link: "https://sdnu.ulearning.cn/kcsz/",
    },
    {
      pic: "10-bjgydx.png",
      link: "",
    },
    {
      pic: "11-zgkydx.png",
      link: "",
    },
    {
      pic: "12-hnlgdx.png",
      link: "",
    },
    {
      pic: "13-zycjdx.png",
      link: "",
    },
    {
      pic: "14-bjlydx.png",
      link: "",
    },
    {
      pic: "15-qlgydx.png",
      link: "https://qlu.kcsz.ulearning.cn/",
    },
    {
      pic: "16-zgdzdx.png",
      link: "",
    },
    {
      pic: "17-whxy.png",
      link: "",
    },
    {
      pic: "18-hbwlxy.png",
      link: "https://hbuas.kcsz.ulearning.cn/",
    },
    {
      pic: "19-nylgxy.png",
      link: "https://hnkcsz.nyist.edu.cn",
    },
    {
      pic: "20-lysfxy.png",
      link: "",
    },
    {
      pic: "21-ahzyydx.png",
      link: "",
    },
    {
      pic: "22-tjdx.png",
      link: "",
    },
    {
      pic: "23-yjlgxy.png",
      link: "",
    },
    {
      pic: "24-lyxy.png",
      link: "",
    },
    {
      pic: "25-gzdx.png",
      link: "",
    },
    {
      pic: "26-hzdzkjdx.png",
      link: "",
    },
    {
      pic: "27-yckjxy.png",
      link: "",
    },
    {
      pic: "28-fskxjsxy.png",
      link: "",
    },
    {
      pic: "29-kjgcdx.png",
      link: "",
    },
    {
      pic: "29-l-hbust.svg",
      link: "https://hbust.kcsz.ulearning.cn/",
    },
    {
      pic: "30-csmz.png",
      link: "http://zyyxdy.ulearning.cn",
    },
    {
      pic: "31-whdl.png",
      link: "",
    },
    {
      pic: "32-sdsl.png",
      link: "",
    },
    {
      pic: "33-nlzyjsxy.png",
      link: "",
    },
    {
      pic: "34-whjszyxy.png",
      link: "",
    },
    {
      pic: "35-hbcsjs.png",
      link: "",
    },
    {
      pic: "36-zjly.png",
      link: "",
    },
    {
      pic: "37-wzzy.png",
      link: "",
    },
    {
      pic: "38-whjt.png",
      link: "",
    },
    {
      pic: "39-szzyjsxy.png",
      link: "https://szpt.kcsz.ulearning.cn/",
    },
    {
      pic: "40-czcsjsxy.png",
      link: "https://czcvc.kcsz.ulearning.cn/",
    },
    {
      pic: "41-gxdlzyjs.png",
      link: "",
    },
    {
      pic: "42-cqgczyjs.png",
      link: "https://cqvie.kcsz.ulearning.cn/",
    },
    {
      pic: "43-qhjtzyjs.png",
      link: "",
    },
    {
      pic: "44-zjjtzy.png",
      link: "",
    },
    {
      pic: "45-whrjgczy.png",
      link: "",
    },
    {
      pic: "46-shjczy.png",
      link: "",
    },
    {
      pic: "47-lzzyjsxy.png",
      link: "",
    },
    {
      pic: "48-bjjjglxu.png",
      link: "",
    },
    {
      pic: "49-gxgjjyzy.png",
      link: "",
    },
  ],
};
export default config;
